/**
 * 表單基本功能按鈕。
 */
export enum MenuItemId {

  /**
   * 新增功能的多國語系 key 名稱
   */
  I18N_ADD = 'button.add',

  /**
   * 編輯功能的多國語系 key 名稱
   */
  I18N_EDIT = 'button.edit',

  /**
   * 放棄功能的多國語系 key 名稱
   */
  I18N_DISCARD = 'button.discard',

  /**
   * 儲存為草稿功能的多國語系 key 名稱
   */
  I18N_SAVE = 'button.save',

  /**
   * 明細功能的多國語系 key 名稱
   */
  I18N_DETAIL = 'button.detail',

  /**
   * 刪除功能的多國語系 key 名稱
   */
  I18N_DELETE = 'button.delete',

  /**
   * 送出功能的多國語系 key 名稱
   */
  I18N_SUBMIT = 'button.submit',

  /**
   * 篩選功能的多國語系 key 名稱
   */
  I18N_FILTER = 'button.filter',

  /**
   * 篩選功能的多國語系 key 名稱
   */
  I18N_FILTER_OFF = 'button.filter-off',

  /**
   * 單身刪除功能的多國語系 key 名稱
   */
  I18N_CLEAR = 'button.clear',

  /**
   * 單頭功能列的編輯按鈕 id
   */
  MASTER_MENU_EDIT = "btnMasterMenuEdit",

  /**
   * 單頭功能列的放棄按鈕 id
   */
  MASTER_MENU_DISCARD = "btnMasterMenuDiscard",

  /**
   * 單頭功能列的送出按鈕 id
   */
  MASTER_MENU_SUBMIT = "btnMasterMenuSubmit",

  /**
   * 單頭功能列的刪除按鈕 id
   */
  MASTER_MENU_DELETE = "btnMasterMenuDelete",

  /**
   * 單身 Table 上方功能列的新增按鈕 id
   */
  DETAIL_MENU_ADD = "btnDetailMenuAdd",

  /**
   * 單身 Table 上方功能列的篩選按鈕 id
   */
  DETAIL_MENU_FILTER = "btnDetailMenuFilter",

  /**
   * 單身 Table 上方功能列的刪除按鈕 id
   */
  DETAIL_MENU_DELETE = "btnDetailMenuDelete",

  /**
   * 單身 Row Action 選單的明細按鈕 id
   */
  ROW_ACTION_MENU_DETAIL = "btnRowActionMenuDetail",

  /**
   * 單身 Row Action 選單的編輯按鈕 id
   */
  ROW_ACTION_MENU_EDIT = "btnRowActionMenuEdit",

  /**
   * 單身 Row Action 選單的刪除按鈕 id
   */
  ROW_ACTION_MENU_DELETE = "btnRowActionMenuDelete"

}
